<template>
  <centered-layout>
    <div class="flex flex-col justify-center itm">
      <h2
        class="text-center text-8xl block font-bold leading-tight text-gray-900"
      >
        404
      </h2>
      <h3 class="text-center text-3xl text-gray-600">Page Not found</h3>
    </div>
  </centered-layout>
</template>

<script>
import CenteredLayout from '@/components/layouts/CenteredLayout.vue'
export default {
  components: {
    CenteredLayout
  }
}
</script>

<style lang="scss" scoped></style>
